import { safeDefine } from "../../registration/safe-define.js";
import { DialogCloseElement } from "../../ui/dialog/close.js";
//#region src/define/ui/dialog-close.ts
safeDefine(DialogCloseElement);
//#endregion

//# sourceMappingURL=dialog-close.js.map